import { useTranslation } from "react-i18next";

// export function that check if the string available in the current language if not return the the available language
export const GetAvailableLanguage = (str: string, i18n) => {

    const lang = localStorage.getItem('lang');
    if(str[lang]) {
        return str[lang];
    }
}